var map = {
	"./ADA.svg": 815,
	"./BCH.svg": 816,
	"./BNB.svg": 817,
	"./BTC.svg": 818,
	"./CHZ.svg": 819,
	"./DASH.svg": 820,
	"./DOGE.svg": 821,
	"./DOT.svg": 822,
	"./ETC.svg": 823,
	"./ETH.svg": 824,
	"./EUR.svg": 825,
	"./GBP.svg": 826,
	"./LINK.svg": 827,
	"./LTC.svg": 828,
	"./MATIC.svg": 829,
	"./MKR.svg": 830,
	"./SHIB.svg": 831,
	"./SOL.svg": 832,
	"./TRX.svg": 833,
	"./UNI.svg": 834,
	"./USD.svg": 835,
	"./USDT.svg": 836,
	"./XLM.svg": 837,
	"./XMR.svg": 838,
	"./XRP.svg": 839,
	"./documents.svg": 840
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 814;